<template>
  <basic-container>
    <el-dialog
      title="文案内容"
      :visible.sync="visible"
      :append-to-body="true"
      width="70%"
      @close="cancel"
    >
      <RichTextEditor v-model="content" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
  import { postChannelManageInstructionSave } from '@/api/channel'
  import RichTextEditor from '@/components/RichTextEditor/RichTextEditor.vue'
  export default {
    components: {
      RichTextEditor
    },
    inject: ['flag'],
    props: {
      show: {
        type: Boolean,
        default: false
      },
      data: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        content: ''
      }
    },
    computed: {
      visible() {
        return this.show
      }
    },
    created() {
      this.content = this.data
    },
    methods: {
      cancel() {
        this.$emit('close')
      },

      async confirm() {
        if (this.content === '') {
          this.$message.error('请输入文案内容')
          return
        }
        if (this.content.length > 5000) {
          this.$message.error('输入内容大小不能超过5000')
          return
        }
        const data = {
          content: this.content,
          type: this.flag
        }
        const res = await postChannelManageInstructionSave(data)
        if (res.code === 0) {
          this.$message.success('保存成功')
          this.$emit('close')
        }
      }
    }
  }
</script>

<style></style>
